import { LocalOperation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { setFormElementSliderValues, SetFormElementSliderValuesAction } from 'store/data/forms';
import { ActionPayload } from 'store/types';

export function useFormElementSliderValues(): LocalOperation<
	(payload: ActionPayload<SetFormElementSliderValuesAction>) => void
> {
	const dispatch = useDispatch();

	function handler(payload: ActionPayload<SetFormElementSliderValuesAction>) {
		dispatch(setFormElementSliderValues(payload));
	}

	return handler;
}
